import React from 'react';
import { twMerge } from 'tailwind-merge';
import Tooltip from './Tooltip';

interface PillProps {
  children: React.ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  tooltip?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  href?: string;
  target?: string;
  rel?: string;
}

const variantClasses = {
  default: 'bg-secondary-blue text-white',
  success: 'bg-green-100 text-green-800',
  warning: 'bg-yellow-100 text-yellow-800',
  error: 'bg-red-100 text-red-800',
  info: 'bg-blue-100 text-blue-800'
};

const sizeClasses = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-3 py-1 text-xs',
  lg: 'px-4 py-2 text-sm'
};

export default function Pill({
  children,
  variant = 'default',
  size = 'sm',
  className = '',
  tooltip,
  style,
  onClick,
  href,
  target,
  rel
}: PillProps) {
  const classNames = twMerge(
    'inline-flex items-center font-medium rounded-[10px]',
    variantClasses[variant],
    sizeClasses[size],
    (onClick || href) && 'cursor-pointer hover:brightness-95',
    className
  );
  const pillContent = href ? (
    <a href={href} target={target} rel={rel} onClick={onClick} className={classNames} style={style}>
      {children}
    </a>
  ) : onClick ? (
    <button type="button" onClick={onClick} className={classNames} style={style}>
      {children}
    </button>
  ) : (
    <span className={classNames} style={style}>
      {children}
    </span>
  );

  if (tooltip) {
    return <Tooltip title={tooltip}>{pillContent}</Tooltip>;
  }

  return pillContent;
}
